import { Fragment } from "react";

/** 文の中の改行（\n）を改行として出す（管理UIの「文言」で改行を入れた文） */
export default function TextLines({ text }: { text: string }) {
  const lines = text.split("\n");
  return (
    <>
      {lines.map((line, i) => (
        <Fragment key={i}>
          {i > 0 && <br />}
          {line}
        </Fragment>
      ))}
    </>
  );
}
